import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ModelPage from './pages/ModelPage';
import { LanguageProvider } from './contexts/LanguageContext';
import { RegisterModalProvider } from './contexts/RegisterModalContext';

function App() {
  return (
    <LanguageProvider>
      <RegisterModalProvider>
        <Router>
          <Routes>
            <Route path="/:id" element={<ModelPage />} />
          </Routes>
        </Router>
      </RegisterModalProvider>
    </LanguageProvider>
  );
}

export default App;
